import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  GiftVariationFragment,
  giftVariationFragmentString,
} from '../../fragments/__generated__/GiftVariationFragment'

import { priceString } from '../../fragments/__generated__/Price'

import { amountString } from '../../fragments/__generated__/Amount'

import getGiftRawString from '../GetGift.graphql'

const getGiftString = [
  getGiftRawString,
  giftVariationFragmentString,
  priceString,
  amountString,
].join('\n\n')

export type GetGiftData = {
  gift: {
    id: string
    realId: string
    __typename: 'Gift'
    name: string
    defaultImageUrl: string
    defaultVariation: Maybe<GiftVariationFragment>
    variations: GiftVariationFragment[]
  }
}

export type GetGiftVariables = {
  id?: Maybe<string>
  slug?: Maybe<string>
}

export type GetGift = Operation<GetGiftData, GetGiftVariables>

export const GetGift = ({ id, slug }: GetGiftVariables = {}): GetGift => ({
  query: getGiftString,
  variables: {
    id,
    slug,
  },
})
